module.exports = __webpack_public_path__ + "static/media/tube_rotor_placed.f0107c5a.svg";